import type { InjectionKey } from 'vue';

export const SESSION_EXPIRED_SIGN_IN: InjectionKey<() => void> = Symbol('vpSessionExpiredSignIn');
